import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useCheckPermission from '../../hooks/useCheckPermission';
import PublisherForm from './PublisherForm';
import publisherService from '../../services/publisherService';
import userGroupService from '../../services/authority/userGroupService';
import publisherTypeService from '../../services/publisherTypeService';

const PublisherCreate = (props: any) => {
  const { onSave = null, navigateBack = true, handleCancel = null } = props;

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const [errors, setErrors] = useState<string[]>([]);
  const [groups, setGroups] = useState<any[]>([]);
  const [publisherTypes, setPublisherTypes] = useState<any[]>([]);

  const { checkPermission } = useCheckPermission();

  useEffect(() => {
    userGroupService.list().then((response: any) => {
      if (!response.hasError) setGroups(response.records);
      else
        enqueueSnackbar(response.errorMessages.join(','), {
          variant: 'error',
        });
    });
  }, []);

  useEffect(() => {
    publisherTypeService.list().then((response: any) => {
      if (!response.hasError) setPublisherTypes(response.records);
      else
        enqueueSnackbar(response.errorMessages.join(','), {
          variant: 'error',
        });
    });
  }, []);

  const onSubmit = (entity: any, setSubmitting: any) => {
    dispatch({ type: 'SHOW_SAVE' });
    publisherService
      .create(entity)
      .then((response) => {
        if (response.hasError) {
          setErrors(response.errorMessages);
          enqueueSnackbar(response.errorMessages.join(','), {
            variant: 'error',
          });
        } else {
          enqueueSnackbar('Success!', {
            variant: 'success',
          });

          if (onSave) onSave(response.result);
          if (navigateBack) navigate(-1);
        }
      })
      .finally(() => {
        dispatch({ type: 'HIDE' });
        if (setSubmitting) setSubmitting(false);
      });
  };

  return (
    <PublisherForm
      entity={{
        name: '',
        email: '',
        website: '',
        imageId: '',
        groupIds: [],
        isInstitution: false,
        publisherTypeId: '',
      }}
      readonly={!checkPermission(['CreatePublisher'])}
      onSubmit={onSubmit}
      errors={errors}
      publisherTypes={publisherTypes}
      onPublisherTypeAdded={(location: any) => {
        setPublisherTypes([...publisherTypes, location]);
      }}
      handleCancel={() =>
        handleCancel != null ? handleCancel() : navigate(-1)
      }
      groups={groups}
    />
  );
};

export default PublisherCreate;
